import { CSSProperties } from "react";
import { Step, StepType } from "../../blocks/order-flow/OrderFlow";
import useBreakpoint from "@src/hooks/use-breakpoint";
import { buildClassString } from "@src/helpers/classBuilder";

interface StepGroupModel {
  itemWidth: number;
  steps: Step[];
  stepIndex: number;
  hasUserGate: boolean;
}

const StepGroup = (model: StepGroupModel) => {
  const { itemWidth, steps, stepIndex, hasUserGate } = model;
  const breakpoint = useBreakpoint();

  return (
    <div className="step-label-group" style={{ "--item-width": itemWidth + "%" } as CSSProperties}>
      {breakpoint === "desktop" ? (
        steps.map((step, index) => {
          if (step.type === StepType.userGate) {
            return <></>;
          }

          const className = buildClassString({ active: index === stepIndex, "screen-center": steps.length === 1 });

          return (
            <span className={className} key={index}>
              {`Step ${hasUserGate ? index : index + 1} : ${step.stepLabel}`}
            </span>
          );
        })
      ) : (
        <span className="active">{`Step ${steps[0].type === StepType.userGate ? stepIndex : stepIndex + 1} of ${
          steps[0].type === StepType.userGate ? steps.length - 1 : steps.length
        }`}</span>
      )}
    </div>
  );
};

export default StepGroup;
